:host{position:absolute;top:50%;left:20%}.handles{text-align:center;margin-bottom:.5rem}
/*# sourceMappingURL=pen.component-IK6GYFIV.css.map */
